import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))
(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'white'
      ? '#FFFFFF'
      : 'hsl(255, 93%, 30%)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div className='p-5' style={{ width: "100%" }}>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ width: '100%' }}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography style={{color:"white"}}>What services do you offer?</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ backgroundColor: '#FFFFFF' }}>
          <Typography>
          We offer residential, commercial, and industrial construction, remodeling, renovations, interior design, and project management.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{ width: '100%' }}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography style={{color:"white"}}>How long will my construction project take?</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ backgroundColor: '#FFFFFF' }}>
          <Typography>
          Project duration depends on the size and complexity. We provide a detailed timeline during the planning stage.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{ width: '100%' }}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography style={{color:"white"}}>Can I make changes after the project has started?</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ backgroundColor: '#FFFFFF' }}>
          <Typography>
          Yes, we accommodate changes when possible. However, changes may affect the cost and timeline.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} style={{ width: '100%' }}>
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography style={{color:"white"}}>How do you determine the cost of a project?</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ backgroundColor: '#FFFFFF' }}>
          <Typography>
          We base our estimates on design, materials, labor, and other specific requirements.
       </Typography>
        </AccordionDetails>
      </Accordion>

    
      
    </div>
  );
}